module.exports = __webpack_public_path__ + "img/bottom.298a3587.png";